import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Input } from 'antd';
import { getUserReportsByEmail } from 'actions/superuser';

const Search = Input.Search;

import './UsersPage.css';
import { NonPsychicReports } from 'elements';


function mapState(state) {
  return {
    ...state.superuser
  };
}

function mapDispatch(dispatch, props) {
  return {
    getUserReportsByEmail(email) {
      return getUserReportsByEmail(dispatch, email);
    }
  };
}

class UsersPage extends Component {

  static propTypes = {
    fPagination: React.PropTypes.object,
    ownUUID: React.PropTypes.string,
    superuser: React.PropTypes.string,
    fConversations: React.PropTypes.array,
    getConversations: React.PropTypes.func
  };

  render() {
    const { user } = this.props;
    return (
      <div className="p-20">
        <Search
          placeholder="input user email"
          onSearch={value => this.props.getUserReportsByEmail(value)}
          size="large"
          enterButton="Search"
        />
        {user ? <NonPsychicReports nonPsychic={user} /> : <div className="no-user">no user found</div>
        }
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(UsersPage));



// WEBPACK FOOTER //
// ./src/pages/user_reports/UsersPage.jsx